import { render, staticRenderFns } from "./dailyTasks.vue?vue&type=template&id=0f8f78ce&scoped=true"
import script from "./dailyTasks.vue?vue&type=script&lang=js"
export * from "./dailyTasks.vue?vue&type=script&lang=js"
import style0 from "./dailyTasks.vue?vue&type=style&index=0&id=0f8f78ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f78ce",
  null
  
)

export default component.exports